module.exports = __webpack_public_path__ + "static/media/Schneegrenze.ecdc94b9.svg";